import { z } from 'zod';

/** @see Manzanita.Web.Areas.Admin.Models.AccessTypeViewModel */
export type AccessTypeModel = z.infer<typeof accessTypeModelSchema>;

export type UserRole = string;

/** @see Manzanita.Web.Areas.Admin.Models.AccessType */
export type AccessType = z.infer<typeof accessTypeSchema>;

/** @see Manzanita.Web.Areas.Admin.Models.AccessType */
export const accessTypeSchema = z.enum([
	'CustomerGroup',
	'Customer',
	'Plant',
	'Country',
	'CustomerGroupPlant',
	'CustomerGroupCountry',
	'All',
]);

/** @see Manzanita.Web.Areas.Admin.Models.AccessTypeViewModel */
export const accessTypeModelSchema = z.object({
	accessType: accessTypeSchema,
	primaryAssociation: z.string().optional().nullable(),
	secondaryAssociation: z.string().optional().nullable(),
});
